const videoManage = () => import("./views/videoManage.vue");

export default {
  // 视频管理管理
  path: "/videoManage",
  name: "videoManage",
  component: videoManage,
  meta: {
    root: "/appCenter"
  }
}



// WEBPACK FOOTER //
// ./src/core/modules/video/router.js